<template>
  <div class="view" data-view>
    <div class="page-not-found">
      <h1 class="title">Página não encontrada</h1>
      <router-link class="redirect" :to="{ name: 'dashboard' }"
        >Voltar para tela inicial</router-link
      >
    </div>
  </div>
</template>

<style scoped>
* {
  font-family: "Dosis", sans-serif !important;
}

.view {
  display: grid;
  place-items: center;
  height: 100vh;
}

.page-not-found {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.title {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 2rem;
  font-weight: bold;
  color: var(--primary-color);
}

.title::after {
  content: "";
  background: url("../assets/static/404/404.png") no-repeat;
  width: 400px;
  height: 400px;
  background-size: contain;
}

.redirect {
  cursor: pointer;
  color: var(--primary-color);
  border: 1px solid var(--primary-color);
  border-radius: 4px;
  padding: 1rem;
  transition: 0.2s all ease-in-out;
}

.redirect:hover {
  color: #fafafa;
  background: var(--primary-color);
}
</style>
